import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtdToSipComponent } from './otd-to-sip.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [OtdToSipComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [OtdToSipComponent]
})
export class OtdToSipModule { }
